import { DocPage, Section, SpecTable, Demo } from "../../components/DocChrome";

export function TokensPage() {
    return (
        <DocPage
            title="Design Tokens"
            description="Primitive → semantic → component. UI code must consume semantic or component tokens, never invent one-off values."
        >
            <Section title="Architecture">
                <Demo title="Tier model">
                    <pre className="overflow-x-auto rounded-mz-md bg-neutral-ink p-4 text-xs text-gold-light">
                        {`primitive  (brand.blue, brand.gold, neutrals…)
    ↓
semantic   (--mz-color-primary, --mz-color-accent, bg/fg/border)
    ↓
component  (button height, input padding, sidebar width)`}
                    </pre>
                </Demo>
            </Section>
            <Section title="Package exports">
                <SpecTable
                    rows={[
                        ["@maeiz/tokens", "Typed values + statusSemantics"],
                        ["@maeiz/tokens/tokens.css", "CSS variables (light + .dark)"],
                        ["@maeiz/tokens/tailwind-preset", "Shared Tailwind preset"],
                    ]}
                />
            </Section>
            <Section title="Rules">
                <ul className="list-disc space-y-1 ps-5">
                    <li>One canonical token per concept — no duplicate families.</li>
                    <li>Extend semantics carefully; never redefine brand blue or gold.</li>
                    <li>Warning amber (`#F59E0B`) is functional, not gold.</li>
                </ul>
            </Section>
        </DocPage>
    );
}
